import React, { useEffect, useRef, useState } from 'react';
import { animate, useInView, useReducedMotion } from 'framer-motion';
type CountUpProps = {
  value: number;
  decimals?: number;
  className?: string;
};

/** Counts from 0 to `value` once when scrolled into view. */
export function CountUp({
  value,
  decimals = 0,
  className = ''
}: CountUpProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    amount: 0.6
  });
  const reduce = useReducedMotion();
  const [display, setDisplay] = useState(reduce ? value : 0);
  useEffect(() => {
    if (!inView || reduce) {
      if (reduce) setDisplay(value);
      return;
    }
    const controls = animate(0, value, {
      duration: 1.1,
      ease: [0.23, 1, 0.32, 1],
      onUpdate: v => setDisplay(v)
    });
    return () => controls.stop();
  }, [inView, value, reduce]);
  return <span ref={ref} className={`tabular-nums ${className}`} data-id="element-183" data-mp="39rgvs0czfcjj">
      {display.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    })}
    </span>;
}